import { createSelector } from '@ngrx/store';
import {
  selectEntityMap,
  selectEntitySlice,
} from '@core/state/entities/entity.selectors';

export const selectRecentProjects = createSelector(
  selectEntitySlice('projectUsages'),
  selectEntityMap('projects'),
  (projectUsagesState, projectsEntityMap) => {
    if (!projectUsagesState || !projectsEntityMap) {
      return [];
    }
    return projectUsagesState.allIds
      .map((puId) => projectUsagesState.byId[puId])
      .sort(
        (a, b) =>
          (a.lastAccessed ? Date.parse(a.lastAccessed) : 0) -
          (b.lastAccessed ? Date.parse(b.lastAccessed) : 0)
      )
      .reverse()
      .map((pu) => projectsEntityMap[pu?.id])
      .filter((p) => !!p);
  }
);

export const selectFirstFiveRecentProjects = createSelector(
  selectRecentProjects,
  (recentProjects) => recentProjects.slice(0, 5)
);

export const selectFavouriteProjects = createSelector(
  selectEntityMap('projectUsages'),
  selectRecentProjects,
  (projectUsagesEntityMap, recentProjects) =>
    projectUsagesEntityMap
      ? recentProjects.filter((p) => projectUsagesEntityMap[p?.id].favourite)
      : []
);
